import React, { Fragment, FunctionComponent } from "react";
import ContentPageProps from "./ContentPageProps.interface";

import ContentPageBlock from "./ContentPage.block";

const ContentPage: FunctionComponent<ContentPageProps> = (props): JSX.Element => {
    return (
        <Fragment>
            {props.blocks?.map((blockContent, index) => {
                return (
                    <ContentPageBlock key={index} {...blockContent} />
                );
            })}
        </Fragment>
    );
};

export default ContentPage;